import { Department } from '../../types/data';
import SortButton from '../sort-button/sort-button';
import { TooltipItem } from "src/utils/Tooltip";

const COLUMNS = {
  '1': {
    width: '600px',
    indent: '0',
  },
  '2': {
    width: '60px',
    indent: '0',
  },
  '3': {
    width: '70px',
    indent: '60px',
  },
  '4': {
    width: '70px',
    indent: '130px',
  },
  '5': {
    width: '120px',
    indent: '200px',
  },
  '6': {
    width: '170px',
    indent: '320px',
  },
};

type TableHeadProps = {
  data: Department[];
  sort?: boolean;
  onChangeSort?: () => void;
  isFactory?: boolean;
};

function TableHead({ data, sort, onChangeSort, isFactory }: TableHeadProps) {
  return (
    <thead className="sticky top-[-1px] z-20 bg-white">
      <tr>
        {!isFactory &&
          <th
            className="sticky z-10 border bg-white p-2.5 text-left text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black"
            style={{
              left: COLUMNS['1'].indent,
              width: `${COLUMNS['1'].width}`,
            }}
          >
            <div className="flex items-center justify-between">
              <span>Блок/Требование</span>

              <TooltipItem
                position="left"
                tooltipsText={sort ? 'Отключить сортировку по фокусным GOP' : 'Сначала фокусные GOP'}
              >
                <SortButton sort={sort} onChangeSort={onChangeSort} />
              </TooltipItem>
            </div>
          </th>
        }

        {isFactory && (
          <>
            <th
              className="sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black"
              style={{
                left: COLUMNS['2'].indent,
                width: `${COLUMNS['2'].width}`,
              }}
            >
              Год
            </th>

            <th
              className="sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black"
              style={{
                left: COLUMNS['3'].indent,
                width: `${COLUMNS['3'].width}`,
              }}
            >
              Квартал
            </th>

            <th
              className="sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black"
              style={{
                left: COLUMNS['4'].indent,
                width: `${COLUMNS['4'].width}`,
              }}
            >
              Завод
            </th>

            <th
              className="sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black"
              style={{
                left: COLUMNS['5'].indent,
                width: `${COLUMNS['5'].width}`,
              }}
            >
              Форма GOP
            </th>

            <th
              className="sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-center text-xs font-medium before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black"
              style={{
                left: COLUMNS['6'].indent,
                width: `${COLUMNS['6'].width}`,
              }}
            >
              Направление/Блок
            </th>
          </>
        )}

        {data.map((el) => (
          <th
            key={el.id}
            className="relative w-[92px] border border-gray-400 px-2.5 py-4 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black"
          >
            {el.title}
          </th>
        ))}

        <th className="relative w-[116px] border border-gray-400 p-2.5 text-center text-xs font-bold after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black">
          Среднее по заводу
        </th>

        {!isFactory && (
          <>
            <th className="relative w-[104px] border border-gray-400 p-2.5 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black">
              Действия
            </th>

            <th className="relative w-[104px] border border-gray-400 p-2.5 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black">
              Комментарии
            </th>
          </>
        )}

        {isFactory && (
          <>
            <th className="relative w-[148px] border border-gray-400 px-2.5 py-4 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black">
              Кто завершил оценку
            </th>

            <th className="relative w-[148px] border border-gray-400 px-2.5 py-4 text-center text-xs font-medium after:absolute after:bottom-[-1px] after:left-0 after:h-[1px] after:w-full after:bg-black">
              Дата завершения
            </th>
          </>
        )}
      </tr>
    </thead>
  );
}

export default TableHead;
